export enum IbInformationStepsEnum{
  VERIFIED = 'VERIFIED',
  COMPLETE_INFORMATION = 'COMPLETE_INFORMATION',
  PROGRESS_ACTIVITY = 'PROGRESS_ACTIVITY'
}
